import s from "./PaymentMethods.module.css";

import React, { useRef, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { PaymentMethod } from "@components/Donat/PaymentMethod";


const PaymentMethods = ({ onEnter, toggle, updateMethod, methods }) => {
  const [active, setActive] = useState("");
  const [toggleDisabled, setToggleDisabled] = useState(false);

  const ref = useRef(null);

  const { t } = useTranslation();

  useEffect(() => {
    onEnter(ref.current.offsetHeight);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref.current?.offsetHeight]);

  return (
    <div className={s.paymentMethodsBlock} ref={ref}>
      <div className={s.subTitle}>{t("Donat.pay")}</div>
      <div className={s.listBtn}>
        {Object.keys(methods).map((method) => {
          const element = methods[method];
          const btnText = t(`Donat.${element.name}`);
          const itsActive = active === element.name;

          return <PaymentMethod itsActive={itsActive} element={element} btnText={btnText} setActive={setActive} key={method}/>;
        })}
      </div>

      <button
        disabled={active === "" || toggleDisabled}
        className={active !== "" ? s.none + " " + s.sendBtn : s.none}
        onClick={() => {setToggleDisabled(true); toggle(); updateMethod(active);}}
      >
        {t("Donat.continue")}
      </button>
    </div>
  );
};

export default PaymentMethods;
